module.exports = __webpack_public_path__ + "media/images/sarapoint/bg-m-986ec07acbb58ff9d7bd53d1faf96688.svg";